export default __webpack_public_path__ + "static/logo-48b53698cdc7fed0f91d524c52086f4f.svg";